"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowChildFactoryFromJS = exports.WindowChildFactory = void 0;
const immutable_1 = require("immutable");
exports.WindowChildFactory = (0, immutable_1.Record)({
    visible: false,
    size: 400,
    hasScrollbars: false,
    title: '',
    showLoading: false,
    contentEditableTitle: false,
    noHeader: false,
    positionRight: null
});
const WindowChildFactoryFromJS = function (data) {
    return (0, exports.WindowChildFactory)(data);
};
exports.WindowChildFactoryFromJS = WindowChildFactoryFromJS;
//# sourceMappingURL=IWindowChild.js.map